import { GanzimmunPreset } from '@/theme/preset'
import { modalTrackingHooks } from '@/composables/modalState'

export const GanzimmunTheme = {
  theme: {
    preset: GanzimmunPreset,
    options: {
      prefix: 'p',
      darkModeSelector: 'dark-mode',
      cssLayer: false
    }
  },
  pt: {
    dialog: { hooks: modalTrackingHooks },
    checkbox: {
      root: {
        onkeydown: (event: KeyboardEvent) => {
          if (event.key !== 'Enter' || event.altKey || event.isComposing) return
          event.preventDefault()
          event.stopPropagation()
          const input = event.target as HTMLInputElement
          if (!event.repeat && !input.readOnly) input.click()
        }
      }
    },
    select: {
      root: {
        onkeydown: (e: KeyboardEvent) => {
          if ((e.key == 'ArrowDown' || e.key == 'ArrowUp') && e.ctrlKey) {
            e.preventDefault()
            const container = Array.from(document.getElementsByClassName('p-select-open'))
            container.forEach((x) => (x as HTMLElement).click())

            const newEvent = new KeyboardEvent('keydown', {
              key: e.key,
              code: e.code,
              keyCode: e.keyCode,
              ctrlKey: e.ctrlKey,
              shiftKey: e.shiftKey,
              altKey: e.altKey,
              metaKey: e.metaKey,
              bubbles: true // Wichtig, damit das Event die DOM-Hierarchie durchläuft
            })
            setTimeout(() => {
              document.dispatchEvent(newEvent)
            }, 0)
          }
        }
      }
    }
  }
}
